"use strict";

module.exports = {
  hasTexture1: false,
  hasTextureCube1: false,

  enableLights: false,
  useReflection: false,

  // picking configs
  enablePicking: false,
  hasPickingColors: false,

  // fog configuration
  hasFog: false
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kZXByZWNhdGVkL3NoYWRlcmxpYi9kZWZhdWx0LXVuaWZvcm1zLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJoYXNUZXh0dXJlMSIsImhhc1RleHR1cmVDdWJlMSIsImVuYWJsZUxpZ2h0cyIsInVzZVJlZmxlY3Rpb24iLCJlbmFibGVQaWNraW5nIiwiaGFzUGlja2luZ0NvbG9ycyIsImhhc0ZvZyJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxlQUFhLEtBREU7QUFFZkMsbUJBQWlCLEtBRkY7O0FBSWZDLGdCQUFjLEtBSkM7QUFLZkMsaUJBQWUsS0FMQTs7QUFPZjtBQUNBQyxpQkFBZSxLQVJBO0FBU2ZDLG9CQUFrQixLQVRIOztBQVdmO0FBQ0FDLFVBQVE7QUFaTyxDQUFqQiIsImZpbGUiOiJkZWZhdWx0LXVuaWZvcm1zLmpzIiwic291cmNlc0NvbnRlbnQiOlsibW9kdWxlLmV4cG9ydHMgPSB7XG4gIGhhc1RleHR1cmUxOiBmYWxzZSxcbiAgaGFzVGV4dHVyZUN1YmUxOiBmYWxzZSxcblxuICBlbmFibGVMaWdodHM6IGZhbHNlLFxuICB1c2VSZWZsZWN0aW9uOiBmYWxzZSxcblxuICAvLyBwaWNraW5nIGNvbmZpZ3NcbiAgZW5hYmxlUGlja2luZzogZmFsc2UsXG4gIGhhc1BpY2tpbmdDb2xvcnM6IGZhbHNlLFxuXG4gIC8vIGZvZyBjb25maWd1cmF0aW9uXG4gIGhhc0ZvZzogZmFsc2Vcbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/react-vis/~/luma.gl/dist/deprecated/shaderlib/default-uniforms.js
// module id = 754
// module chunks = 0